<button type="button" class="btn cancel-button" (click)="openConfirmDialog()">{{ 'Home' | translate }}</button>
